import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

export default function DropdownMenu({ dataId }) {
  const apiURL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation().pathname;
  const [isOpen, setIsOpen] = useState(false);
  
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    try {
      let data = JSON.stringify({
        userName: "Admin",
        refreshToken: `${localStorage.getItem("refreshToken")}`,
      });

      let config = {
        method: "post",
        url: `${apiURL}/User/Logout`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: data,
      };

      const response = await axios.request(config);
      if (response.data.status) {
        localStorage.clear();
        navigate("/");
      }
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <>
      <div className="position-relative" ref={dropdownRef}>
        {/* Button to open dropdown */}
        <button
          className="btn btn-light border-0 bg-transparent"
          onClick={() => setIsOpen(!isOpen)}
        >
          <i className="fas fa-user fs-5"></i>
        </button>

        {/* Dropdown Menu */}
        <ul
          className={`dropdown-menu ${isOpen ? "show" : ""}`}
          style={{
            position: "absolute",
            top: "40px",
            left: "-117px",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
            borderRadius: "8px",
            zIndex: 1050,
          }}
        >
          <li
            className="dropdown-item logoutBtn"
            onClick={handleLogout}
            style={{
              cursor: "pointer",
              marginTop: "6px",
              // color: "white",
            }}
          >
            <i className="fas fa-sign-out-alt me-2"></i> Logout
          </li>
        </ul>
      </div>
    </>
  );
}
